import { word } from "@modules/core/utils/i18n"
import { ProgramBundleListLayout } from "@modules/programBundle/components/programBundleListLayout"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { TrainingProgramsFiltersView } from "@modules/training/components/trainingProgramsFilterView"
import { MenuItem } from "primereact/menuitem"
import { TabMenu } from "primereact/tabmenu"
import { useTransition } from "react"

type TrainingProgramsTabProps = {
  allowProgramSelection?: boolean
} & React.HTMLAttributes<HTMLDivElement>

export const TrainingProgramsTab: React.FC<TrainingProgramsTabProps> = ({ allowProgramSelection, ...props }) => {
  const defaultClassName = "flex flex-column"
  const [, startTransition] = useTransition()
  const { getCurrentStackState, setCurrentStackState } = useSidebar()
  const activeIndex = getCurrentStackState("activeTabIndex") ?? 0

  const items: MenuItem[] = [
    { label: word("trainingPrograms.tabs.programs") },
    { label: word("trainingPrograms.tabs.packs") },
  ]

  function selectTab(index: number) {
    startTransition(() => {
      setCurrentStackState("activeTabIndex", index)
    })
  }

  return (
    <div className={props.className ? props.className : defaultClassName} {...props}>
      <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => selectTab(e.index)} className="w-full" />
      {activeIndex === 0 && <TrainingProgramsFiltersView allowProgramSelection={allowProgramSelection ?? false} />}
      {activeIndex === 1 && <ProgramBundleListLayout />}
    </div>
  )
}
